export default {
  CreateSettlementTitle: 'Choose a sponsor',
  createSettlementDescription: 'To continue, choose one of the following options',
  cutoffTitle: 'Cut-off range',
  cutoffDescription: 'Chose a date range',
  error: 'An error occurred when creating the settlement',
  steper: { 
    sponsorSelection: "Sponsor selection",
    authorizations: "Authorizations"
  },
  buttons: {
    next: "Next",
    back: "Back",
    cancel: "Cancel",
    end: "Finish",
    changeSponsor: "Change"
  },
  title: {
    text: 'Crear radicación',
    back: 'Cancelar'
  },
  dates: {
    init: "From",
    final: "To"
  },
  authorizations: {
    cutoffRange: "Cut-off range",
    totalResults: "{total} results",
    selectedRows: "{selected} selected",
    chooseTitle: "Choose the authorizations you want to add to the settlement",
    chooseDescription: "You can unselect authorizations",
    selectAll: "Select all",
    grid: {
      id: "ID",
      createdAt: "Created At",
      beneficiaryName: "Beneficiary",
      memberCode: "Member code",
      coverage: "Coverage"
    }
  }
}